<div class="summary-loader h-100 w-100 d-flex flex-column justify-content-betwee" *ngIf="showLoader">
    <div class="h-100 p-x-page-thanks d-flex flex-column flex-nowrap justify-content-center" >
      <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <img class="loading-image" src="../assets/video/loader.gif">
      </div>
      <div class="row text-center d-flex flex-row flex-nowrap justify-content-center align-items-center">
        <h2 class="accent loading-text">
          {{ "b2c.IDS_LOADING_TEXT" | translate }}
        </h2>
      </div>
    </div>
  </div>
  <div class="summary-view p-t-block d-flex h-100" *ngIf="!showLoader">
    
    <header *ngIf="(header.question || header.showSubtitle || header.showSubtitleInfo || header.showAddonTitle)">
      <div class="row" *ngIf="header.showAddonTitle">
        <div class="p-x-page p-x-page-thermo">
          <h6 class="m-y-0 addon-title" [innerHTML] = "header.addonTitle | translate"></h6>
        </div>
      </div>
        <div class="row" *ngIf="header.question">
          <div class="p-x-page p-t-page-title p-x-page-thermo">
            <h1 class="m-y-0" [innerHTML]= "header.question | translate"></h1>
          </div>
        </div>
        <div class="row d-flex p-x-page m-subtitle align-items-center p-x-page-thermo" *ngIf="header.showSubtitle"          
        >
          <div class="d-inline-flex"
            *ngIf="header.showSubtitle"
          >
            <div>
              <h6 class="font-weight-normal m-y-0" [innerHTML]="header.subtitle | translate"></h6>
            </div>
          </div>
        </div>
    </header>

    <div class="col-1 w-50">
  
      <div class="justify-content-center">
        <h2>          
          {{ "b2c.IDS_YOUR_PROJECT" | translate }}
        </h2>
        <span class="font-p2">          
          Questa sono le tue scelte che verranno inviate all’installatore.
        </span>
        <h3>
          N° preventivo: {{ UUID }}
        </h3>
        <div class="justify-content-center homewifi-cont"><!--p-x-page-->
          <div class="d-flex flex-column">
            <span class="label3">{{ "b2c.IDS_ESTIMATED_QUOTE" | translate }}</span>
            <span class="label2 m-t-8">{{ minRange | number: '1.0-0':'it-IT'}} / {{maxRange | number: '1.0-0':'it-IT'}} €</span>
  
            <!-- <div class="m-t-8 justify-content-center ">
              <span class="d-inline-block v-align-center line-height-20 cursor-pointer" (click)="reviewBtnClick()">
                <i class="bticino-ico eye black small v-align-center line-height-20"></i>
                <span class="line-height-20 label4">
                  {{ "b2c.IDS_REVIEW" | translate }}
                </span>
              </span>
            </div> -->
          </div>
          <span class="bticino-ico homewifi"></span>
        </div>
      </div>
    </div>
  
    <div class="col-2 w-50">
      <div class="">
        <div class="summary-choices-box m-t-60 panel-description">
            <h4 class="summary-section-title">{{ "b2c.IDS_YOUR_ROOMS" | translate }}</h4>
            <ul>
              <li *ngFor="let room of ds.getSelectedRooms()"><b>{{ room.SubRooms[0].Quantity }}</b>  {{ room.RoomGroupName | translate }}</li>
            </ul>
        </div>
        <div class="summary-choices-box m-t-24 panel-description">
          <h4 class="summary-section-title">{{ "b2c.IDS_YOUR_SYSTEMS" | translate }}</h4>
          <ul class="font-p2">
            <li *ngFor="let sys of ds.getSystems(true)">
              {{ sys.Description+'_B2C' | translate }}
              <ul *ngIf="sys.ID == 10">              
                <ng-container *ngFor="let entry of ds.getInternalUnit();">
                  <li *ngIf="entry.quantity > 0">
                    <b>{{entry.quantity}}</b> {{ entry.name | translate }}
                  </li>
                </ng-container>
              </ul>
              <ul *ngIf="sys.ID == 5">              
                <ng-container *ngFor="let entry of ds.getSmartThermo();">
                  <li>
                    <b>{{entry.quantity}}</b> {{ entry.name }}
                  </li>
                </ng-container>
                <ng-container *ngFor="let entry of ds.getSmartThermoAddon();">
                  <li *ngIf="entry.quantity > 0">
                    <b>{{entry.quantity}}</b> {{ entry.name }}
                  </li>
                </ng-container>
              </ul>
              <ul *ngIf="sys.ID == 4">              
                <ng-container *ngFor="let entry of ds.getSmartCamera();">
                  <li *ngIf="entry.quantity > 0">
                    <b>{{entry.quantity}}</b> {{ entry.name }}
                  </li>
                </ng-container>
                <ng-container *ngFor="let entry of ds.getSmartCameraAddon();">
                  <li *ngIf="entry.quantity > 0">
                    <b>{{entry.quantity}}</b> {{ entry.name }}
                  </li>
                </ng-container>
              </ul>
            </li>
          </ul>
        </div>
        <div class="summary-choices-box m-t-24 m-b-48 panel-description" *ngIf="!(ds.getBoolHavingBTicino() && ds.whatToDoIsUpdateImplant())">
            <h4 class="summary-section-title">{{ "b2c.IDS_FINISHING" | translate }}</h4>
            <div class="summary-finishing-image">
              <div class="result" [ngClass]="{'livinglight': ds.getFinishingID() == 3}">
                <div class="black-background" *ngIf="ds.getFinishingID() != 4"></div>
                <img class="plate-img" [src]="plateUrl" *ngIf="plateUrl">
                <div class="buttons" *ngIf="switchesUrl">
                    <img [src]="switchesUrl">
                </div>
              </div>
            </div>
            <div class="summary-finishing-text">
              <p>{{'b2c.IDS_SERIES' | translate }}: <b> {{ ds.getFinishing().name | translate}}</b></p>
              <p>{{'b2c.IDS_PLATE' | translate }}: <b *ngIf="ds.getPlate()">{{ ds.getPlate().Color | translate }}</b></p>
              <p>{{(ds.getFinishingID() == 4 ? 'b2c.IDS_COVER' : 'b2c.IDS_BUTTON') | translate }}: <b *ngIf="ds.getSwitch()">{{ ds.getSwitch().name | translate }}</b></p>
            </div>
          </div>
        </div>
    </div>
  </div>
  
  
  